import React from "react";
import { motion } from "framer-motion";

/**
 * SlideCard — wrapper con animación de entrada desde un lado
 * @param {"left"|"right"} direction  - lado desde el que entra
 * @param {string}         className  - clases adicionales del contenedor
 * @param {number}         distance   - píxeles de desplazamiento inicial (default 70)
 * @param {number}         threshold  - fracción visible para activar (default 0.2)
 */
export default function SlideCard({
    direction = "left",
    children,
    className = "",
    distance = 70,
    threshold = 0.2,
}) {
    const x = direction === "left" ? -distance : distance;

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, x }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            viewport={{ once: true, amount: threshold }}
        >
            {children}
        </motion.div>
    );
}
